/* Bestillingsinstruksjoner → cart.note (2026-08-02).
   Én global kontroller uansett hvor mange instanser som rendres (skuff +
   /cart). Debounce 900 ms + lagring ved blur; «Til kassen» venter på at
   lagringen er ferdig før videresending. /cart.js-verdien er fasit. */
(function () {
  'use strict';
  if (window.ZenzCartNote) { window.ZenzCartNote.bind(); return; }

  var timer = null, dirty = false, lagringPagar = null, siste = null;

  function felter() { return Array.prototype.slice.call(document.querySelectorAll('[data-zenz-note]')); }
  function settStatus(tekst, feil) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zenz-note-status]'), function (s) {
      s.textContent = tekst;
      s.classList.toggle('er-feil', !!feil);
    });
  }
  function synk(verdi, unntak) {
    felter().forEach(function (f) { if (f !== unntak && f !== document.activeElement) f.value = verdi || ''; });
  }

  function lagre() {
    var verdi = siste;
    dirty = false;
    settStatus('Lagrer …');
    lagringPagar = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: verdi })
    }).then(function (r) {
      if (!r.ok) throw new Error('note_failed');
      return r.json();
    }).then(function (kurv) {
      settStatus('Instruksjonene er lagret');
      synk(kurv.note);
      window.setTimeout(function () { if (!dirty) settStatus(''); }, 4000);
    }).catch(function () {
      dirty = true;
      settStatus('Kunne ikke lagre – prøv igjen', true);
    }).finally(function () { lagringPagar = null; });
    return lagringPagar;
  }

  function flush() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (dirty) return lagre();
    return lagringPagar || Promise.resolve();
  }

  function bind() {
    felter().forEach(function (f) {
      if (f.dataset.zenzNoteBundet) return;
      f.dataset.zenzNoteBundet = '1';
      f.addEventListener('input', function () {
        siste = f.value; dirty = true;
        synk(f.value, f);
        if (timer) clearTimeout(timer);
        timer = window.setTimeout(lagre, 900);
      });
      f.addEventListener('blur', function () {
        if (dirty) { if (timer) { clearTimeout(timer); timer = null; } lagre(); }
      });
    });
  }
  bind();

  /* «Til kassen» skal aldri forbigå en uferdig lagring. Fanger både lenkene
     (skuff) og skjemaknappene (/cart, sticky) i capture-fasen. */
  document.addEventListener('click', function (e) {
    var maal = e.target.closest('a[href="/checkout"], #CheckOut, .zenz-ck-sticky__btn');
    if (!maal) return;
    if (!dirty && !lagringPagar) return;
    e.preventDefault();
    e.stopPropagation();
    flush().then(function () {
      if (maal.tagName === 'A') { window.location.href = maal.href; return; }
      var form = document.getElementById('cart');
      if (form) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = 'checkout'; i.value = '';
        form.appendChild(i);
        form.submit();
      } else {
        window.location.href = '/checkout';
      }
    });
  }, true);

  window.ZenzCartNote = { flush: flush, bind: bind };
})();
